var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#FEFEFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 8.66667H17V6.7619C17 4.13333 14.76 2 12 2C9.24 2 7 4.13333 7 6.7619V8.66667H6C4.9 8.66667 4 9.52381 4 10.5714V20.0952C4 21.1429 4.9 22 6 22H18C19.1 22 20 21.1429 20 20.0952V10.5714C20 9.52381 19.1 8.66667 18 8.66667ZM12 17.2381C10.9 17.2381 10 16.381 10 15.3333C10 14.2857 10.9 13.4286 12 13.4286C13.1 13.4286 14 14.2857 14 15.3333C14 16.381 13.1 17.2381 12 17.2381ZM15.1 8.66667H8.9V6.7619C8.9 5.13333 10.29 3.80952 12 3.80952C13.71 3.80952 15.1 5.13333 15.1 6.7619V8.66667Z",
    fill: "#F6A400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockV2);
export default __webpack_public_path__ + "static/media/lockV2.239f3e32.svg";
export { ForwardRef as ReactComponent };